import {getResource} from "./common"

export type OutreachSettings = {
	type: "emailOutreachSettings" | "messageOutreachSettings"
	id: string
	attributes: {
		createdAt: Date
		updatedAt: Date
		name: string
		domain?: string
		sender?: {
			email: string
			name: string
		}
		isVerified?: boolean
		senderPhone?: {
			countryCode: string
			number: string
		}
		messageChannels?: ["Sms"]
	}
}

export async function getEmailOutreachSettings(accessToken: string) {
	const result = await getResource<OutreachSettings[]>("outreach-settings", accessToken)
	return result.map((v) => v.data.filter((setting) => setting.type === "emailOutreachSettings"))
}
